import React from "react";
import Navbar from "../components/navigation/Navbar";
import CreateTeam from "../components/CreateTeam";

function Team() {
  return (
    <>
      <Navbar />
      <p>Team Home Page</p>
      <CreateTeam />
    </>
  );
}

export default Team;
